import styled from "styled-components";

import { ReactComponent as home } from "../assets/icons/home.svg";
import { ReactComponent as award } from "../assets/icons/award.svg";
import { ReactComponent as contact } from "../assets/icons/contact.svg";
import { ReactComponent as portfolio } from "../assets/icons/portfolio.svg";

const HomeIcon = styled(home)``;
const AwardIcon = styled(award)``;
const ContactIcon = styled(contact)``;
const PortfolioIcon = styled(portfolio)``;

export const navbar = [
  {
    id: 1,
    title: "Home",
    path: "/home",
    icon: <HomeIcon />,
  },
  {
    id: 2,
    title: "Portfolio",
    path: "/portfolio",
    icon: <PortfolioIcon />,
  },
  {
    id: 3,
    title: "Awards",
    path: "/awards",
    icon: <AwardIcon />,
  },
  {
    id: 4,
    title: "Contact",
    path: "/contact",
    icon: <ContactIcon />,
  },
];
